module.exports = __webpack_public_path__ + "img/receive.e1830011.svg";